/**
 * GENERATED by `pnpm assets:frames` from
 * `assets-src/profile/avatar-frames/*.png` — do not edit by hand.
 *
 * Where each avatar frame's ring actually sits inside its artwork. Only the
 * ring frames the avatar; the laurels, plates and thorns hung off it are free
 * to spill anywhere, and do so differently on every frame. `AvatarDisplay`
 * scales and offsets the art so this circle lands on the avatar, which keeps
 * the framing identical no matter how the decoration changes.
 */
export interface AvatarFrameMetrics {
  /** width / height of the shipped (trimmed) art. */
  readonly aspectRatio: number;
  /** Ring centre from the left edge, as a fraction of width. */
  readonly ringCenterX: number;
  /** Ring centre from the top edge, as a fraction of height. */
  readonly ringCenterY: number;
  /** Radius of the ring's opening, as a fraction of width. */
  readonly ringRadius: number;
}

export const AVATAR_FRAME_METRICS: Record<string, AvatarFrameMetrics> = {
  "ancient-gold": {
    "aspectRatio": 0.9767,
    "ringCenterX": 0.4989,
    "ringCenterY": 0.4959,
    "ringRadius": 0.4081
  },
  "candlelit-brass": {
    "aspectRatio": 0.9543,
    "ringCenterX": 0.4977,
    "ringCenterY": 0.5274,
    "ringRadius": 0.3611
  },
  "emerald-thorn": {
    "aspectRatio": 1.0231,
    "ringCenterX": 0.4996,
    "ringCenterY": 0.4635,
    "ringRadius": 0.3667
  },
  "forgotten-library": {
    "aspectRatio": 1,
    "ringCenterX": 0.4994,
    "ringCenterY": 0.4879,
    "ringRadius": 0.3554
  },
  "runed-oak": {
    "aspectRatio": 1.0891,
    "ringCenterX": 0.4984,
    "ringCenterY": 0.4941,
    "ringRadius": 0.308
  }
};
